module.exports = __webpack_public_path__ + "static/img/sexual_violence_4.df3eb0d8.png";